import { useAnalytics } from '@growth/use-analytics';
import React, { useState, useEffect } from 'react';
import { _ as _taggedTemplateLiteralLoose } from '../../../dist/taggedTemplateLiteralLoose-8a80a17d.esm.js';
import styled, { css } from 'styled-components';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var InpElWrap = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\tposition: relative;\n\twidth: ", ";\n\tpadding: 18px 14px;\n\tborder-radius: 4px;\n\n\tborder: ", ";\n"])), function (props) {
  return props.width ? props.width : '';
}, function (props) {
  return (// eslint-disable-next-line no-nested-ternary
    props.hasError ? '1px solid #FF3A5C;' : props.isActive ? '1px solid #2276E3;' : '1px solid rgba(0, 0, 0, 0.12)'
  );
});
var InpElLabel = styled.label(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\tfont-weight: bold;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcolor: #777777;\n\tposition: absolute;\n\ttop: 18px;\n\tleft: 14px;\n\tbackground-color: #fff;\n\tpadding: 0 4px;\n\ttransition: 0.2s all;\n\tcursor: text;\n"])));
var InputElement = styled.input(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n\tfont-style: normal;\n\tfont-weight: bold;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcolor: #141823;\n\tborder: none;\n\twidth: 100%;\n\toutline: none;\n\t", ";\n\t", "\n\n\t&:focus ~ label {\n\t\ttop: -8px;\n\n\t\tfont-size: 12px;\n\t\tline-height: 16px;\n\t\tcolor: ", ";\n\t\tfont-weight: normal;\n\t}\n\n\t::-webkit-outer-spin-button,\n\t::-webkit-inner-spin-button {\n\t\t-webkit-appearance: none;\n\t\tmargin: 0;\n\t}\n"])), function (props) {
  return props.disabled && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n\t\t\tbackground-color: #ffffff;\n\t\t\tcolor: #777777;\n\t\t"])));
}, function (props) {
  return props.hasValue && css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n\t\t\t~ label {\n\t\t\t\ttop: -8px;\n\n\t\t\t\tfont-size: 12px;\n\t\t\t\tline-height: 16px;\n\t\t\t\tfont-weight: normal;\n\t\t\t}\n\t\t"])));
}, function (props) {
  return props.hasError ? '#FF3A5C' : '#2276e3';
});

var InputField = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$label = props.label,
      label = _props$label === void 0 ? '' : _props$label,
      _props$width = props.width,
      width = _props$width === void 0 ? '328px' : _props$width,
      inpValue = props.inpValue,
      handleChange = props.handleChange,
      _props$inputType = props.inputType,
      inputType = _props$inputType === void 0 ? 'text' : _props$inputType,
      _props$isDisabled = props.isDisabled,
      isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled,
      _props$hasError = props.hasError,
      hasError = _props$hasError === void 0 ? false : _props$hasError,
      _props$readOnly = props.readOnly,
      readOnly = _props$readOnly === void 0 ? false : _props$readOnly,
      maxLength = props.maxLength,
      defaultValue = props.defaultValue;

  var _useState = useState(false),
      isFocused = _useState[0],
      setIsFocused = _useState[1];

  var _useAnalytics = useAnalytics(),
      analyticsTrackAll = _useAnalytics.analyticsTrackAll;

  var handleInputChange = function handleInputChange(event) {
    if (handleChange) {
      handleChange(event.target.value);
    }
  };

  var renderLabelValue = function renderLabelValue(focus) {
    if (!inpValue || inpValue.length === 0) {
      if (focus) {
        return "" + label || '';
      }

      return "Enter " + label || '';
    }

    return label || '';
  };

  useEffect(function () {
    if (hasError) {
      analyticsTrackAll('form-field-error', {
        item_selected: hasError
      });
    }
  }, [hasError]);

  var handleInputClick = function handleInputClick(event) {
    analyticsTrackAll('form-field-clicked', {
      item_selected: label
    });
    event.stopPropagation();
    setIsFocused(true);

    if (ref && ref.current) {
      var _ref$current;

      (_ref$current = ref.current) == null ? void 0 : _ref$current.focus();
    }
  };

  return /*#__PURE__*/React.createElement(InpElWrap, {
    width: width,
    isActive: isFocused,
    hasError: hasError
  }, /*#__PURE__*/React.createElement(InputElement, {
    hasValue: inpValue && (inpValue == null ? void 0 : inpValue.length) > 0,
    hasError: hasError,
    disabled: isDisabled,
    readOnly: readOnly,
    id: label,
    type: inputType,
    value: inpValue,
    onClick: handleInputClick,
    onBlur: function onBlur() {
      setIsFocused(false);
    },
    onChange: handleInputChange,
    maxLength: maxLength,
    ref: ref,
    defaultValue: defaultValue
  }), /*#__PURE__*/React.createElement(InpElLabel, {
    htmlFor: label
  }, renderLabelValue(isFocused)));
});
InputField.defaultProps = {
  inputType: 'text',
  label: undefined,
  width: undefined,
  inpValue: undefined,
  handleChange: undefined,
  isDisabled: false,
  hasError: false,
  readOnly: false,
  maxLength: undefined,
  defaultValue: undefined
};
InputField.displayName = 'InputField';

export { InputField as default };
